import _taggedTemplateLiteral from "/Users/diego.sampaio/olx/connecting/chat-frontend/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
var _templateObject, _templateObject2, _templateObject3, _templateObject4;
import styled, { keyframes } from 'styled-components';
import { spinnerDefaultProps } from './props';
export const CircleStrokeKeyframe = keyframes(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  0% {\n    stroke-dasharray: 1px, 200px;\n    stroke-dashoffset: 0px;\n  }\n  50% {\n    stroke-dasharray: 100px, 200px;\n    stroke-dashoffset: -15px;\n  }\n  100% {\n    stroke-dasharray: 100px, 200px;\n    stroke-dashoffset: -125px;\n  }\n"])));
export const CircleSpinnerKeyframe = keyframes(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  0% {\n    transform-origin: 50% 50%;\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n"])));
export const CircleSpinningContainer = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  ", ";\n  width: ", ";\n  height: ", ";\n  animation: ", " 1.4s linear infinite;\n  z-index: var(--z-index-800-spinner, 800);\n"])), _ref => {
  let {
    color
  } = _ref;
  return color != 'currentColor' && "color: var(".concat(color, ")");
}, _ref2 => {
  let {
    size = spinnerDefaultProps.size
  } = _ref2;
  return "var(--spinner-".concat(size, "-size)");
}, _ref3 => {
  let {
    size = spinnerDefaultProps.size
  } = _ref3;
  return "var(--spinner-".concat(size, "-size)");
}, CircleSpinnerKeyframe);
export const AnimatedStrokeCircle = styled.circle(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  stroke: currentColor;\n  stroke-dasharray: 80px, 200px;\n  stroke-dashoffset: 0px;\n  animation: ", " 1.4s ease-in-out infinite;\n  z-index: var(--z-index-800-spinner, 800);\n"])), CircleStrokeKeyframe);